import { memo, type PropsWithChildren } from 'react';
import { ButtonLink } from '~/components/ui/Link';
import { menuStore, type SettingsPage } from '~/lib/stores/menu';

interface SettingsLinkProps {
  text?: string;
  page?: SettingsPage;
  screen?: string;
}

function showSettings(page?: SettingsPage, screen?: string) {
  menuStore.openDialog({ type: 'settings', initialPage: page, screen });
}

export const SettingsLink = memo<PropsWithChildren<SettingsLinkProps>>(({ page, screen, children }) => {
  return <ButtonLink onClick={() => showSettings(page, screen)}>{children}</ButtonLink>;
});
